module.exports = __webpack_public_path__ + "static/media/58.8a7d4e10.jpg";